import { Component, OnInit } from '@angular/core';
import { SessionCartService } from '../../event/session-cart/session-cart.service';
import { ActivatedRoute } from '@angular/router';
import { RegistrationServiceFactory } from '../registration-service.factory';
import { LabelsService } from '../../../services/labels.service';
import { Observable } from 'rxjs';
import { ActiveEventService } from "src/app/services/active-event.service";
import { Event } from "../../../models/Event";

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
    private readableEventId: string;
    public event: Event;
    public confirmtext: string;

    constructor(
        private route: ActivatedRoute,
        private cartService: SessionCartService,
        private labelsService: LabelsService,
        private registrationServiceFactory: RegistrationServiceFactory,
        private activeEventService: ActiveEventService,
    ) {}

    ngOnInit() {
        this.readableEventId = this.route.snapshot.queryParams['id'];

        this.cartService.flushCart(this.readableEventId);
        this.registrationServiceFactory.dispose(this.readableEventId);

        this.getEventAndSessionData().then(async () => {
            this.confirmtext =this.event.customFields.ave_eventportalregistrationpopupmessagetext;
        });


        // history.pushState(null, null, document.URL);
        // window.addEventListener("popstate",function(e) {  
        //   console.log(e);
        //   history.pushState(null, null, document.URL);
        // }, false);


        // if(window.history && window.history.pushState) {
        //     window.onpopstate=function () {
        //             history.replaceState("", "", document.URL);
        //             window.history.pushState('forward', null, '');
        //             window.history.forward();
        //     };
        // }
        // window.history.pushState('forward', null, '');//在IE中必须得有这两行
        // window.history.forward();
 
        // window.addEventListener("popstate", function(e) {
        //     window.history.forward();
        // }, false);

         window.addEventListener('popstate', function (a) {
            var url =window.localStorage.getItem('backUrl');
            window.localStorage.removeItem('backUrl');
            window.location.href =url;
        });
    }

    private async getEventAndSessionData(): Promise<void> {
        try {
            this.event = await this.activeEventService.getEvent(this.readableEventId).toPromise();
        } catch (error) {
            console.error(error);
        }
    }

    public translateLabel(translationKey: string, defaultValue: string): Observable<string> {
        return this.labelsService.translateLabel(translationKey, defaultValue);
    }
}
